import { render, staticRenderFns } from "./Login-comp.vue?vue&type=template&id=524ddf7e&scoped=true&"
import script from "./Login-comp.vue?vue&type=script&lang=js&"
export * from "./Login-comp.vue?vue&type=script&lang=js&"
import style0 from "./Login-comp.vue?vue&type=style&index=0&id=524ddf7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ddf7e",
  null
  
)

export default component.exports